import StimulusDialog from "@stimulus-components/dialog";

export default class Dialog extends StimulusDialog {
  // Function to override on open.
  open(event) {
    const eventId = event.detail?.id;
    const elementId = this.element?.id;

    if ((eventId && eventId === elementId) || !eventId) {
      // a-t-on un turboFrame dans la modale ?
      const turboFrame = this.element.querySelector("turbo-frame");

      if (turboFrame) {
        // Si oui on l'attend
        this.waitForFrame(turboFrame);
      } else {
        this.dispatchOpening();
        super.open();
      }
    }
  }

  waitForFrame(frame) {
    this.dispatchOpening();
    frame.addEventListener("turbo:frame-load", super.open(), { once: true });
    frame.addEventListener("turbo:frame-missing", super.open(), { once: true });
  }

  dispatchOpening() {
    this.element.dispatchEvent(
      new CustomEvent("dialog:opened", { bubbles: true })
    );
  }

  closeFromOutside(event) {
    if (!event) {
      this.close();
    }
    const eventId = event.detail?.id;
    const elementId = this.element?.id;
    if (eventId) {
      // Pourquoi filtrons nous si l'event a un id et que l'element en a un aussi ?
      if (eventId === elementId) {
        this.element.dispatchEvent(
          new CustomEvent("dialog:closed", {
            detail: { closed: true }, // Données optionnelles
            bubbles: true, // Permet à l’événement de remonter dans le DOM
          })
        );
        this.close();
      }
    } else if (!elementId) {
      this.close();
    }
  }

  // Ajout d'une fonction de fermeture pour ne pas retoucher à closeFromOutside
  forceClosing() {
    this.element.dispatchEvent(
      new CustomEvent("dialog:closed", {
        detail: { closed: true }, // Données optionnelles
        bubbles: true, // Permet à l'événement de remonter dans le DOM
      })
    );
    this.close();
  }
}
